import * as React from 'react';
import loadable from '@loadable/component';

import { Skeleton } from '../../../../components/EstimationChart';
import { TRefWrapper } from '../../../Scrolling';

interface IProps {
  refWrapper: TRefWrapper;
}

/* istanbul ignore next */
export const EstimationChartLogicContainerLoadable = loadable<IProps>(() => import('./EstimationChartLogicContainer'), {
  fallback: <Skeleton />,
  ssr: false,
});
